(function ($) {
	// On Dom Ready
	$(function () {
		// === Filter Team Members ===
		var filters_data = {};
		var search_form_selector = ".search-form.news-search-form";
		var selected_filter = null;
		var selected_category = null;
		var selected_team = null;
		var selected_service = null;
		var selected_industry = null;

		// on form submission
		$(search_form_selector).on("submit", function (e) {
			e.preventDefault();

			if ($("#search_keyword").val()) {
				filters_data.keyword = $("#search_keyword").val();
			} else {
				delete filters_data.keyword;
			}

			filter_news();
		});

		// on filters change
		$(search_form_selector)
			.find("#filter_category, #filter_team, #filter_service, #filter_industry")
			.on("change", function (e) {
				e.preventDefault();
				$(search_form_selector).submit();
				selected_filter = $(this).attr('id');
				if(selected_filter === 'filter_category'){
					selected_category = $(this).find('option:selected').val();
				}
				if(selected_filter === 'filter_team'){
					selected_team = $(this).find('option:selected').val();
				}
				if(selected_filter === 'filter_service'){
					selected_service = $(this).find('option:selected').val();
				}
				if(selected_filter === 'filter_industry'){
					selected_industry = $(this).find('option:selected').val();
				}
			});

		// clear search
		$(search_form_selector)
			.find(".btn-clear-search")
			.on("click", function (e) {
				e.preventDefault();
				$("#search_keyword").val("");
				delete filters_data.keyword;
				filter_news();
			});

		// clear filters
		$(search_form_selector)
			.find(".clear-filters")
			.on("click", function (e) {
				e.preventDefault();

				$(search_form_selector).trigger("reset");

				$("select", search_form_selector)
					.prop("selectedIndex", 0)
					.selectric("refresh");

				$(".first-letter-link").removeClass("active");

				filters_data = {};

				filter_news();

				selected_category = null;
				selected_team = null;
				selected_service = null;
				selected_industry = null;

				$(document.body).trigger("news-filters-cleared");
			});

		// things to do after filters updated
		$(document.body).on("news-filters-updated", function (e) {
			e.preventDefault();
			console.log("news filters updated");

			// generate url & update it
			var url = new URL($("#base_url").val());
			window.history.replaceState({}, "", url.href);

			if (Object.keys(filters_data).length > 0) {
				// loop through each filter
				for (const [key, value] of Object.entries(filters_data)) {
					url.searchParams.set(key, value);
				}

				window.history.replaceState({}, "", url.href);
			}

			// show/hide clear filters button
			if (Object.keys(filters_data).length > 0) {
				$(".clear-filters-wrapper").addClass("active");
			} else {
				$(".clear-filters-wrapper").removeClass("active");
			}
		});

		// things to do after filters cleared
		$(document.body).on("news-filters-cleared", function (e) {
			e.preventDefault();
			console.log("news filters cleared");
		});

		// common function to filter team members
		function filter_news() {
			if ($("#filter_category").val()) {
				filters_data.filter_category = $("#filter_category").val();
			} else {
				delete filters_data.filter_category;
			}

			if ($("#filter_team").val()) {
				filters_data.filter_team = $("#filter_team").val();
			} else {
				delete filters_data.filter_team;
			}

			if ($("#filter_service").val()) {
				filters_data.filter_service = $("#filter_service").val();
			} else {
				delete filters_data.filter_service;
			}

			if ($("#filter_industry").val()) {
				filters_data.filter_industry = $("#filter_industry").val();
			} else {
				delete filters_data.filter_industry;
			}

			// show/hide clear search button
			if ($("#search_keyword").val()) {
				$(".keyword-wrapper").addClass("active");
			} else {
				$(".keyword-wrapper").removeClass("active");
			}

			console.log(filters_data);

			// ajax request
			var data = {
				action: "filter_news",
				security: js_params.ajax_nonce,
				...filters_data,
			};

			var listing_element = $(".news-list-wrapper");

			// ajax request to retrieve posts.
			$.ajax({
				url: js_params.ajaxurl,
				data: data,
				type: "POST",
				beforeSend: function (xhr) {
					listing_element.append(
						'<div class="loading"><div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div>'
					);
				},
				success: function (data) {
					if (data) {
						listing_element.html(data);
						$(document.body).trigger("news-filters-updated");
					}
				},
			});

			// ajax request to retrieve dropdown data.
			data.action = 'filter_news_dropdowns';

			$.ajax({
				url: js_params.ajaxurl,
				data: data,
				type: "POST",
				beforeSend: function (xhr) {
				},
				success: function (data) {
					if (data) {
						// Update "Category" dropdown
						if(selected_filter !== 'filter_category' && data.category_dropdown){
							let category_dropdown = data.category_dropdown;
							category_dropdown = Object.entries(category_dropdown);

							$("#filter_category").html(`<option value="">Category</option>`);
							category_dropdown.forEach((category_dropdown_item) => {
								$("#filter_category").append(`<option value="${category_dropdown_item[0]}">${category_dropdown_item[1]}</option>`);
							});

							$("#filter_category").selectric("refresh");
						}

						// Update "Team" dropdown
						if(selected_filter !== 'filter_team' && data.team_dropdown){
							let team_dropdown = data.team_dropdown;
							team_dropdown = Object.entries(team_dropdown);

							let team_dropdown_last_names = data.team_dropdown_last_names;
							team_dropdown_last_names = Object.entries(team_dropdown_last_names);
							team_dropdown_last_names.sort(function(a, b) {
								if (a[1] < b[1]) {
									return -1;
								}
								if (a[1] > b[1]) {
									return 1;
								}
								return 0;
							});

							$("#filter_team").html(`<option value="">Team</option>`);
							team_dropdown_last_names.forEach((team_dropdown_last_name) => {
								$("#filter_team").append(`<option value="${team_dropdown_last_name[0]}">${ getTeamMemberName(team_dropdown_last_name[0], team_dropdown) }</option>`);
							});

							$("#filter_team").selectric("refresh");
						}

						// Update "Services" dropdown
						if(selected_filter !== 'filter_service' && data.services_dropdown){
							let services_dropdown = data.services_dropdown;
							services_dropdown = Object.entries(services_dropdown);

							$("#filter_service").html(`<option value="">Services</option>`);

							// first, separate parent and child items
							const parentItems = services_dropdown.filter(item => item[1].parent_id === 0);
							parentItems.forEach(parent_item => {
								// append parent option
								$("#filter_service").append(`<option value="${parent_item[0]}">${parent_item[1].title}</option>`);

								// find and append child options
								services_dropdown
									.filter(child_item => child_item[1].parent_id === parseInt(parent_item[0]) )
									.forEach(child_item => {
										$("#filter_service").append(`<option class="indent" value="${child_item[0]}">${child_item[1].title}</option>`);
									});
							});

							$("#filter_service").selectric("refresh");
						}

						// Update "Industries" dropdown
						if(selected_filter !== 'filter_industry' && data.industries_dropdown){
							let industries_dropdown = data.industries_dropdown;
							industries_dropdown = Object.entries(industries_dropdown);
							$("#filter_industry").html(`<option value="">Industries</option>`);
							industries_dropdown.forEach((industries_dropdown_item) => {
								$("#filter_industry").append(`<option value="${industries_dropdown_item[0]}">${industries_dropdown_item[1]}</option>`);
							});

							$("#filter_industry").selectric("refresh");
						}

						$('#filter_team').val(selected_team).selectric('refresh');
						$('#filter_service').val(selected_service).selectric('refresh');
						$('#filter_industry').val(selected_industry).selectric('refresh');
						$('#filter_category').val(selected_category).selectric('refresh');
					}
					else{
						console.log('nothing found...');
					}
				},
			});
		}

		if(! $('body').hasClass('page-template-team-landing-template')){
			update_filters_on_page_load();
		}

		function update_filters_on_page_load(){
			// get selected filters on page load from query string
			const urlParams = new URLSearchParams(window.location.search);
			selected_category = urlParams.get('filter_category');
			selected_team = urlParams.get('filter_team');
			selected_service = urlParams.get('filter_service');
			selected_industry = urlParams.get('filter_industry');

			// console.log(selected_category, selected_team, selected_service, selected_industry);

			// ajax request to retrieve dropdown data.
			const data = {
				action: 'filter_news_dropdowns',
				security: js_params.ajax_nonce,
				filters_data: []
			};

			$.ajax({
				url: js_params.ajaxurl,
				data: data,
				type: "POST",
				beforeSend: function (xhr) {
				},
				success: function (data) {
					if (data) {
						// Update "Category" dropdown
						if(selected_filter !== 'filter_category' && data.category_dropdown){
							let category_dropdown = data.category_dropdown;
							category_dropdown = Object.entries(category_dropdown);
							category_dropdown.sort(function(a, b) {
								if (a[1] < b[1]) {
									return -1;
								}
								if (a[1] > b[1]) {
									return 1;
								}
								return 0;
							});

							$("#filter_category").html(`<option value="">Category</option>`);
							category_dropdown.forEach((category_dropdown_item) => {
								$("#filter_category").append(`<option value="${category_dropdown_item[0]}">${category_dropdown_item[1]}</option>`);
							});

							$("#filter_category").selectric("refresh");
						}

						// Update "Team" dropdown
						if(selected_filter !== 'filter_team' && data.team_dropdown){
							let team_dropdown = data.team_dropdown;
							team_dropdown = Object.entries(team_dropdown);

							let team_dropdown_last_names = data.team_dropdown_last_names;
							team_dropdown_last_names = Object.entries(team_dropdown_last_names);
							team_dropdown_last_names.sort(function(a, b) {
								if (a[1] < b[1]) {
									return -1;
								}
								if (a[1] > b[1]) {
									return 1;
								}
								return 0;
							});

							$("#filter_team").html(`<option value="">Team</option>`);
							team_dropdown_last_names.forEach((team_dropdown_last_name) => {
								$("#filter_team").append(`<option value="${team_dropdown_last_name[0]}">${ getTeamMemberName(team_dropdown_last_name[0], team_dropdown) }</option>`);
							});

							$("#filter_team").selectric("refresh");
						}

						// Update "Services" dropdown
						if(selected_filter !== 'filter_service' && data.services_dropdown){
							let services_dropdown = data.services_dropdown;
							services_dropdown = Object.entries(services_dropdown);
							services_dropdown.sort(function(a, b) {
								if (a[1].title < b[1].title) {
									return -1;
								}
								if (a[1].title > b[1].title) {
									return 1;
								}
								return 0;
							});



							$("#filter_service").html(`<option value="">Services</option>`);
							// first, separate parent and child items
							const parentItems = services_dropdown.filter(item => item[1].parent_id === 0);
							parentItems.forEach(parent_item => {
								// append parent option
								$("#filter_service").append(`<option value="${parent_item[0]}">${parent_item[1].title}</option>`);

								// find and append child options
								services_dropdown
									.filter(child_item => child_item[1].parent_id === parseInt(parent_item[0]) )
									.forEach(child_item => {
										$("#filter_service").append(`<option class="indent" value="${child_item[0]}">${child_item[1].title}</option>`);
									});
							});

							$("#filter_service").selectric("refresh");
						}

						// Update "Industries" dropdown
						if(selected_filter !== 'filter_industry' && data.industries_dropdown){
							let industries_dropdown = data.industries_dropdown;
							industries_dropdown = Object.entries(industries_dropdown);
							industries_dropdown.sort(function(a, b) {
								if (a[1] < b[1]) {
									return -1;
								}
								if (a[1] > b[1]) {
									return 1;
								}
								return 0;
							});

							$("#filter_industry").html(`<option value="">Industries</option>`);
							industries_dropdown.forEach((industries_dropdown_item) => {
								$("#filter_industry").append(`<option value="${industries_dropdown_item[0]}">${industries_dropdown_item[1]}</option>`);
							});

							$("#filter_industry").selectric("refresh");
						}

						$('#filter_team').val(selected_team).selectric('refresh');
						$('#filter_service').val(selected_service).selectric('refresh');
						$('#filter_industry').val(selected_industry).selectric('refresh');
						$('#filter_category').val(selected_category).selectric('refresh');
					}
					else{
						console.log('nothing found...');
					}
				},
			});
		}

		function getTeamMemberName(source_index, items) {
			let teamMemberName = '';
			items.forEach((item) => {
				if(item[0] === source_index){
					teamMemberName = item[1];
				}
			});
			return teamMemberName;
		}
	});
})(jQuery);
